<template>
    <div>
        <GridPage
            ref="gridPage"
            :form-default="{
                boxes: [],
                items: [],
                attributes: {
                    is_ignitability: false,
                },
                status: 'suspended',
                _no_importer: false,
            }"
            :filters-default="{
                shipping_courier: 'dhl,shipper_maker,ups,fedex',
                created_at: '',
                sort: '-created_at',
            }"
            :filter-items="[
                {
                    vModel: 'created_at',
                    title: '作成日',
                    type: 'date-range',
                    options: {
                        force_range: false,
                    },
                },
                {
                    vModel: 'sort',
                    title: '順番',
                    options: [
                        { text: '▲ 作成日', value: 'created_at', },
                        { text: '▼ 作成日', value: '-created_at' },
                    ],
                },
            ]"
            filters-q-placeholder="発送人氏名、発送人電話、発送人メール、Tuskey発送番号（#数字）"
            form-modal-id="shipping"
            search-action="shipping/index"
            :filter-search-results="filterSearchResults"
            row-class="flex-nowrap mx-0 my--2"
            :hide-download="false"
            :hide-table="true"
            :open-detail-after-saving="false"
            item-id="id"
            @after-save="afterSave"
            @after-destroy="afterDestroy"
            >
            <template v-slot:form="{ form, init }">
                <Shipping :model="form" :init="init" @save="$refs.gridPage.save" @destroy="$refs.gridPage.destroy"></Shipping>
            </template>

            <template v-slot:before-filter>
            </template>

            <template v-slot:after-table>
                <ShippingTable ref="table" mode="read" @on-detail="onDetail" @after-destroy="afterDestroy" />
            </template>
        </GridPage>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GridPage from '@/components/GridPage.vue'
import Shipping from '@/components/Shipping.vue'
import ShippingBadges from '@/components/ShippingBadges.vue'
import ItemThumb from '@/components/ItemThumb.vue'
import ItemInfo from '@/components/ItemInfo.vue'
import ShippingTable from '@/components/ShippingTable.vue'

export default {
    components: {
        GridPage,
        Shipping,
        ShippingBadges,
        ItemThumb,
        ItemInfo,
        ShippingTable,
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'auth_uuid',
            'trans',
        ])
    },
    data() {
        return {}
    },
    methods: {
        filterSearchResults(response) {
            if (response.data && response.data.hits) {
                this.$refs.table.loadData(response.data.hits)
            } else {
                this.$refs.table.loadData([])
            }
            this.$refs.table.setup()
            return response
        },
        afterSave() {
            this.$refs.gridPage.search()
        },
        afterDestroy() {
            this.$refs.gridPage.search()
        },
        onDetail(item) {
            this.$refs.gridPage.detail(item)
        },
    },
}
</script>

